import {InputNumber, Modal, Radio, Row, Col} from 'antd';
import {useState} from "react";
import {InventoryAdjustmentType} from "../../api/Constants";

export const QuantityAdjust = ({onAdjust, props, children}) => {
    const [isOpen, setOpen] = useState(false);
    const [adjustment, setAdjustment] = useState(0);
    const [mode, setMode] = useState(0);

    const adjustForSubtract = (value, mode) => {
        return ((mode === InventoryAdjustmentType.Subtract) && (value > 0)) ?
            // turn the value negative
            -value : value;
    }

    const onOpen = () => {
        setOpen(true);
    }

    const onOk = () => {
        setOpen(false)
        if (onAdjust) {
            onAdjust(adjustForSubtract(adjustment, mode), mode);
        }
    }

    const onCancel = () => {
        setOpen(false);
    }

    const onInputChange = (val) => {
        console.log(val);
        if (val) {
            setAdjustment(val);
        } else {
            setAdjustment(0);
        }
    }

    const onModeChange = (e) => {
        setMode(e.target.value);
    }

    const radioOptions = [
        { value: InventoryAdjustmentType.Add, label: "Add Inventory" },
        { value: InventoryAdjustmentType.Subtract, label: "Remove Inventory"},
        { value: InventoryAdjustmentType.Set, label: "Set Inventory"}
    ]

    const radioStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
    }

    let quantity = ((mode === InventoryAdjustmentType.Subtract) && (adjustment < 0)) ? - adjustment : adjustment;
    const messages = [
        `${adjustment} will be added`,
        `${quantity} will be subtracted`,
        `inventory will be set to ${adjustment}`
    ];
    const message = messages[mode];

    return <div>
            <div style={{cursor: 'pointer', color: "#108ee9"}} onClick={onOpen}>{children}</div>
            <Modal width={400} open={isOpen} onOk={onOk} onCancel={onCancel}>
                <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col><InputNumber style={{width: 300}} precision={0} onChange={onInputChange} /></Col>
                </Row>
                <Radio.Group style={radioStyle} defaultValue={mode} options={radioOptions} onChange={onModeChange}></Radio.Group>
                <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col style={{color: 'red'}}>{message}</Col>
                </Row>
            </Modal>
        </div>
}